import React from 'react';
import styled, { createGlobalStyle, css } from 'styled-components';

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px;
  width: 100px;
  opacity: ${props => props.enabled ? 1 : 0.6};
  cursor: ${props => props.enabled ? (props.draggable ? 'move' : 'pointer') : 'not-allowed'};
  
  &:hover {
    background: ${props => props.enabled ? 'rgba(255, 255, 255, 0.1)' : 'transparent'};
  }
  
  &.selected {
    background: rgba(255, 255, 255, 0.2);
  }

  &.melting {
    transition: none !important;
    will-change: transform;
    
    ${props => props.isMelting && css`
      animation: bounce-chaos-${props.index} 3.5s cubic-bezier(.25,.82,.25,.95) forwards;
      animation-delay: ${Math.random() * 0.2}s;
      animation-fill-mode: forwards;
      animation-iteration-count: 1;
      animation-timing-function: steps(20, end);

      @keyframes bounce-chaos-${props.index} {
        0% {
          transform: translate(0, 0) rotate(0deg);
        }
        20% {
          transform: translate(${Math.random() * window.innerWidth * 0.8}px, ${Math.random() * (window.innerHeight - 200)}px) rotate(${Math.random() * 360}deg);
        }
        40% {
          transform: translate(${Math.random() * window.innerWidth * 0.8}px, ${Math.random() * (window.innerHeight - 200)}px) rotate(${Math.random() * 720 - 360}deg);
        }
        60%, 100% {
          transform: translate(${Math.random() * window.innerWidth * 0.8}px, ${Math.random() * (window.innerHeight - 200)}px) rotate(${Math.random() * 1080 - 540}deg);
        }
      }
    `}
  }
`;

const IconSymbol = styled.div`
  font-size: 32px;
  margin-bottom: 5px;
`;

const IconLabel = styled.div`
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);
  font-family: 'VT323', monospace;
  font-size: 16px;
  color: white;
  text-align: center;
  word-wrap: break-word;

  &.melting {
    text-shadow: none;
  }
`;

const IconImage = styled.img`
  width: 48px;
  height: 48px;
  image-rendering: pixelated;
  margin-bottom: 8px;
  transition: filter 0.3s;

  &.cmd-icon:hover {
    filter: brightness(1.5);
  }

  &.melting {
    filter: none;
  }
`;

const IconStyles = createGlobalStyle`
  .cmd-icon .cursor {
    opacity: 0;
  }

  .cmd-icon:hover {
    .prompt {
      animation: promptPulse 1s infinite;
    }
    
    .cursor {
      opacity: 1;
      animation: blink 1s infinite;
    }
  }

  @keyframes blink {
    0%, 100% { opacity: 1; }
    50% { opacity: 0; }
  }

  @keyframes promptPulse {
    0%, 100% { stroke: #33ff33; }
    50% { stroke: #1a8f1a; }
  }
`;

export const DesktopIcon = ({ 
  icon, 
  label, 
  isSelected, 
  onClick, 
  onDoubleClick, 
  onContextMenu,
  enabled = true,
  draggable,
  onDragStart,
  onDrag,
  onDragEnd,
  style,
  className,
  index
}) => {
  return (
    <>
      <IconStyles />
      <IconWrapper
        className={`${isSelected ? 'selected' : ''} ${className || ''}`}
        onClick={onClick}
        onDoubleClick={onDoubleClick}
        onContextMenu={onContextMenu}
        enabled={enabled}
        draggable={draggable}
        onDragStart={onDragStart}
        onDrag={onDrag}
        onDragEnd={onDragEnd}
        style={style}
        index={index}
        isMelting={className?.includes('melting')}
      >
        <IconImage 
          src={icon} 
          alt={label} 
          className={`${label === 'Command Prompt' ? 'cmd-icon' : ''} ${className || ''}`}
        />
        <IconLabel className={className || ''}>{label}</IconLabel>
      </IconWrapper>
    </>
  );
};